var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import cc from 'classcat';
import SmallArrowBackIcon from '../../assets/icons/small-arrow-back.svg';
import SmallArrowForwardIcon from '../../assets/icons/small-arrow-forward.svg';
import './tile-navigation-buttons.style.scss';
/**
 * Spinner to show on when loading
 */
var TileNavigationButtons = function (props) {
    var navigateLeft = props.navigateLeft, navigateRight = props.navigateRight, leftDisabled = props.leftDisabled, rightDisabled = props.rightDisabled, navRef = props.navRef, className = props.className, rest = __rest(props, ["navigateLeft", "navigateRight", "leftDisabled", "rightDisabled", "navRef", "className"]);
    return (React.createElement("div", __assign({ className: cc([className, 'tfm-tile-navigation-buttons']) }, rest, { ref: navRef }),
        React.createElement("button", { type: "button", "aria-label": "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7", onClick: navigateLeft, 
            // onTouchEndCapture={navigateLeft}
            disabled: leftDisabled },
            React.createElement(SmallArrowBackIcon, null)),
        React.createElement("button", { type: "button", "aria-label": "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7", onClick: navigateRight, 
            // onTouchEndCapture={navigateRight}
            disabled: rightDisabled },
            React.createElement(SmallArrowForwardIcon, null))));
};
TileNavigationButtons.defaultProps = {
    leftDisabled: true,
    rightDisabled: true,
};
export default memo(TileNavigationButtons);
